import {Page} from 'page/utils';
import SearchTracking from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import getFilters from '../utils/filters';
import getParkingType from '../utils/parking-type';
import getTopSearchResults from '../utils/top-search-results';

export default function trackMapAdjusted({
    actionType,
    city,
    filters,
    sortBy,
    isMonthly,
    pageType,
    spots,
    mapBounds,
}) {
    const isEvent = pageType === Page.EVENT;
    const isAirport = pageType === Page.AIRPORT;
    const {searchUUID, actionUUID} = SearchTracking.getValues();
    const center = mapBounds.getCenter();
    const neBounds = mapBounds.getNorthEast();
    const swBounds = mapBounds.getSouthWest();
    const properties = {
        action_id: actionUUID,
        action_type: actionType,
        availability_check: actionType !== 'ZOOM_IN',
        city,
        filters: getFilters(filters),
        map_center: {
            latitude: center.lat(),
            longitude: center.lng(),
        },
        map_coordinates: {
            northeast: {
                latitude: neBounds.lat(),
                longitude: neBounds.lng(),
            },
            southwest: {
                latitude: swBounds.lat(),
                longitude: swBounds.lng(),
            },
        },
        parking_type: getParkingType({isMonthly, isAirport, isEvent}),
        search_id: searchUUID,
        top_search_results_list: getTopSearchResults({
            filters,
            spots,
            isMonthly,
            sortBy,
        }).topSpots,
    };

    SegmentUtils.track({
        event: 'Map Adjusted',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
